import { Tab } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { TimetableSubjectContainersSubpage } from './TimetableSubjectContainersSubpage';
import { TimetableSubjectGroupsSubpage } from './TimetableSubjectGroupsSubpage';
import { TimetableSubjectsSubpage } from './TimetableSubjectsSubpage';

export const TimetableSetupSubjectsAndSubjectContainer = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadTimetable()}>
      <Tab
        variant='large'
        tabs={[
          {
            title: t('subject.title', { count: 2 }),
            value: 'subjects',
            content: <TimetableSubjectsSubpage />,
          },
          {
            title: t('subjectContainer.title', { count: 2 }),
            value: 'subjectsContainer',
            content: <TimetableSubjectContainersSubpage />,
          },
          {
            title: t('subjectGroup.title', { count: 2 }),
            value: 'subjectGroup',
            content: <TimetableSubjectGroupsSubpage />,
          },
        ]}
      />
    </Page>
  );
};
